/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import { createUploadLink } from 'apollo-upload-client'
import { onError } from '@apollo/client/link/error'
import { ApolloClient, from, InMemoryCache } from '@apollo/client'
import { useEffect, useState } from 'react'

export const useConfigClient = (jwtState) => {
  const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL
  const [authTokenStorage, setAuthTokenStorage] = useState(localStorage.getItem('twt'))   // by default it is null

  useEffect(() => {
    setAuthTokenStorage(localStorage.getItem('jwt')) // as soon as it is available just update the token
  }, [jwtState])

  const httpLink = new createUploadLink({
    uri: GRAPHQL_URL,
    headers: {
      Authorization: `Bearer ${authTokenStorage}`
    }
  })

  const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (const { message } of graphQLErrors) {
        if (message === 'Unauthenticated.') {
          localStorage.clear(); // Clear localStorage
          window.location.href = '/login'; // Redirect to the login page
        }
      }
    }

    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
    }

    forward(operation);
  });

  const client = new ApolloClient({
    link: from([errorLink, httpLink]),
    cache: new InMemoryCache({
      typePolicies: {
        // Folder: {
        //   keyFields: ['folder_id']
        // },
        ProductCategory: {
          keyFields: ['categorie_id']
        },
        site: {
            keyFields: ['site_id']
        },
        // Products: {
        //   keyFields: ['product_id']
        // },
        // ProductDetail: {
        //   keyFields: ['naam', 'product_file']
        // }
      }
    })
  })

  return client
}
